import React from "react";
import styled from "styled-components";
import PaymentIcon from "react-payment-icons-inline";
import {Pencil} from "styled-icons/heroicons-outline/Pencil";
import {useDataSource} from "src/core/data-sources/decorators/withData";
import useRouter from "src/core/common/hooks/useRouter";
import {
  ModalActionContainer,
  ModalSectionButton,
  ModalText,
  ModalTitle,
  ModalSubText,
} from "src/core/common/components/modules/modal/modalComponents";
import MerrcoPaymentSourcesDataSource from "src/core/payments/merrco/merccoPaymentSourcesDataSource";
import PaymentSource from "src/core/payments/PaymentSource";
import {cardTypes} from "src/core/payments/CardComponents/cardTypes";
import MerrcoIcon from "src/core/common/assets/merrco.svg";

export default function Merrco({editCardRoute}) {
  const router = useRouter();

  const merrcoPaymentSourcesDataSource = new MerrcoPaymentSourcesDataSource();
  const {merrcoPaymentSources} = useDataSource(
    {},
    {
      dataSource: merrcoPaymentSourcesDataSource,
      keyFields: [""],
      dataField: "merrcoPaymentSources",
    }
  );
  const defaultMerrcoPaymentMethod =
    merrcoPaymentSources && merrcoPaymentSources.find((pSource) => pSource.isDefault);

  return (
    <>
      <ModalTitle>Cards</ModalTitle>
      <ModalSectionButton
        data-cy="defaultCardPaymentListButton"
        onClick={() =>
          router.push({pathname: editCardRoute, params: {creditCardType: "merrco"}})
        }
      >
        <ModalText>
          {defaultMerrcoPaymentMethod ? (
            <ProviderContainer>
              <PaymentSource
                readOnly={true}
                isExpired={defaultMerrcoPaymentMethod.isExpired}
                institution={null}
                institutionName={defaultMerrcoPaymentMethod.getMaskLabel()}
                label={defaultMerrcoPaymentMethod.getExpiryLabel()}
                paymentDate={null}
                icon={
                  <PaymentIcon
                    icon={cardTypes[defaultMerrcoPaymentMethod.institution]}
                    style={{width: 40, height: 25}}
                  />
                }
              />
            </ProviderContainer>
          ) : (
            "Set default payment card..."
          )}
        </ModalText>
        <ModalActionContainer>
          <PencilIcon />
        </ModalActionContainer>
      </ModalSectionButton>
      <ModalSubText>
        <MerrcoIcon style={{paddingTop: 3}} />
        Powered by Merrco
      </ModalSubText>
    </>
  );
}

const ProviderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const PencilIcon = styled(Pencil)`
  height: 20px;
  width: 20px;
  color: black;
`;
